module.exports = __webpack_public_path__ + "img/_6.49808f23.png";